webpackJsonp([70906191779010],{

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 3 },
	            "longus"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "us"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "am"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "orum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "arum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "orum"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "os"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "as"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "Het rijtje van ",
	        _react2.default.createElement(
	          "strong",
	          null,
	          "longus"
	        ),
	        " gaat in feite hetzelfde als de rijtjes van",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "zelfstandig-naamwoord" },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "servus"
	          ),
	          ", ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            "femina"
	          ),
	          " en",
	          " ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            "donum"
	          )
	        ),
	        "."
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 3 },
	            "longus"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "us"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "am"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "orum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "arum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "orum"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "os"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "as"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "long\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "Het rijtje van ",
	        _react2.default.createElement(
	          "strong",
	          null,
	          "longus"
	        ),
	        " gaat in feite hetzelfde als de rijtjes van",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "zelfstandig-naamwoord" },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "servus"
	          ),
	          ", ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            "femina"
	          ),
	          " en",
	          " ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            "donum"
	          )
	        ),
	        "."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "fortis"
	          ),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "ingens"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mnl/vrl"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mnl/vrl"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fortis"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "e"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingens",
	            _react2.default.createElement("strong", null)
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingens",
	            _react2.default.createElement("strong", null)
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingent\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingent\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingent\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingent\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "em"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "e"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingent\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "em"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingens",
	            _react2.default.createElement("strong", null)
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ingent\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ingent\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "es"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ia"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingent\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "es"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingent\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ia"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ium"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ium"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingent\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ium"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingent\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ium"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingent\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingent\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "es"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ia"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingent\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "es"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingent\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ia"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "fort\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingent\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ingent\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ibus"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "De rijtjes van ",
	        _react2.default.createElement(
	          "strong",
	          null,
	          "fortis"
	        ),
	        " en ",
	        _react2.default.createElement(
	          "strong",
	          null,
	          "ingens"
	        ),
	        " gaan grotendeels hetzelfde als de rijtjes van",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "zelfstandig-naamwoord" },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "rex"
	          ),
	          " en ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            "nomen"
	          )
	        ),
	        "."
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableSelector = __webpack_require__(28);
	
	var _TableSelector2 = _interopRequireDefault(_TableSelector);
	
	var _bnw = __webpack_require__(644);
	
	var _bnw2 = _interopRequireDefault(_bnw);
	
	var _bnw3 = __webpack_require__(645);
	
	var _bnw4 = _interopRequireDefault(_bnw3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = [{
	  les: "15",
	  table: _bnw2.default
	}, {
	  les: "16",
	  table: _bnw4.default
	}];
	
	exports.default = function () {
	  return _react2.default.createElement(_TableSelector2.default, {
	    defaultChapter: "16",
	    data: data,
	    title: "Bijvoeglijk naamwoord"
	  });
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-spqr-rijtjes-bijvoeglijk-naamwoord-js-58833d704c69cae7bcff.js